import {z} from 'zod';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {
  DTProductSelectionNode,
  ProductSelectionConfiguration,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {productCardSchema} from '../../../../../schemas/productCardSchema';
import {
  DefaultCardOutputsWithPartialSuccess,
  DefaultCardOutputs,
  defaultCustomMatchingConfiguration,
} from '../../utils/convertCardSchemaToCard/convertCardSchemaToCard.consts';
import {ProductSelectionStrategyType} from 'common/src/modules/productSelectionStrategies/productSelectionStrategies.types';
import {getAICardBaseDetails} from '../../utils/getAICardBaseDetails';

export function convertProductAICardToAPICard(
  productCard: z.input<typeof productCardSchema>,
  existingCard: DTProductSelectionNode | undefined,
) {
  const isPartialSuccessStrategy = [
    ProductSelectionStrategyType.ProductMatching,
    ProductSelectionStrategyType.ViewedItems,
  ].includes(productCard.productsSelectionStrategy);

  //if the card has outputs, use them, otherwise use the default outputs by products selection strategy
  let outputs =
    existingCard?.outputs ??
    (isPartialSuccessStrategy ? DefaultCardOutputsWithPartialSuccess : DefaultCardOutputs);

  //if the products selection strategy has changed, use the default outputs by products selection strategy
  if (
    !!existingCard &&
    (existingCard as unknown as DTProductSelectionNode).productsSelectionStrategy !==
      productCard.productsSelectionStrategy
  ) {
    outputs = isPartialSuccessStrategy ? DefaultCardOutputsWithPartialSuccess : DefaultCardOutputs;
  }

  if (isPartialSuccessStrategy) {
    outputs = DefaultCardOutputsWithPartialSuccess;
  }

  const configuration: ProductSelectionConfiguration | undefined = isPartialSuccessStrategy
    ? defaultCustomMatchingConfiguration
    : undefined;

  if (configuration && productCard.conditions?.length > 0) {
    configuration.conditions = productCard.conditions.map((condition) => ({
      feedColumnSignalKey: condition.feedColumnSignalKey,
      operator: condition.operator,
      signalKey: condition.signalKey,
      feedColumnUIName: condition.feedColumnUIName,
      signalMainCategory: condition.signalMainCategory,
      signalUIName: condition.signalUIName,
    }));
  }

  return {
    ...getAICardBaseDetails(productCard),
    type: NodeType.PRODUCTS,
    productsSelectionStrategy: productCard.productsSelectionStrategy,
    feedId: productCard.feedId ?? 0,
    productIds: productCard.productIds,
    topItemLogicId: productCard.topItemsListId ?? 0,
    retargetingProductSetId: productCard.productSetId ?? 0,
    categoryTopItemsLogicId: productCard.categoryTopItemsListId ?? 0,
    configuration,
    outputs,
  } satisfies Omit<DTProductSelectionNode, 'id' | 'inputs'>;
}
